import { ROUTERS } from "@/shared/constants/router";
import { useAuthStore } from "@/store/useAuth";
import { redirect } from "@tanstack/react-router";

export function requireGuest() {
  if (useAuthStore.getState().accessToken) {
    throw redirect({
      to: ROUTERS.HOME,
      replace: true,
    });
  }
}
